<template>
  <div>
    <div class="desktop faq-linker-hero">
      <h1>자주묻는 질문</h1>
    </div>
    <div class="mobile m-faq-linker-hero">
      <h1>Linker</h1>
      <p>자주묻는 질문</p>
    </div>
    <b-container>
      <b-row>
        <b-col sm="11" md="8" offset-md="2">
          <div class="faq-wrapper">
            <div class="faq-question" @click="toggle(1)">
              <span class="desktop">Q. 링커는 가전제품과 얼마나 떨어져 있어도 되나요?</span>
              <span class="mobile">Q. 링커는 가전제품과<br>얼마나 떨어져 있어도 되나요?</span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isFirstDropdownOpen}"><img src="@/assets/btn-dropdown-faq.png"></span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isFirstDropdownOpen}">
              <p>리모컨의 작동원리와 유사합니다. 열린 공간 기준 가전제품 제어는 7m까지 가능합니다.<br>
              단, 연결 거리와 상관없이 중간에 장애물이나 벽이 있을 경우 제어가 불가능할 수 있습니다.</p>
            </div>
            <div class="faq-question" @click="toggle(2)">
              <span class="desktop">Q. 전자 제품은 최대 몇 개까지 링커에 연결할 수 있나요?</span>
              <span class="mobile">Q. 전자 제품은 최대 몇개까지<br>링커에 연결할 수 있나요?</span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isSecondDropdownOpen}"><img src="@/assets/btn-dropdown-faq.png"></span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isSecondDropdownOpen}">
              <p>링커에 연결할 수 있는 기기 숫자는 제한이 없습니다. 다만 링커 또한 리모컨처럼 같은 방에<br>
              있는 가전제품을 제어할 수 있기 때문에 설치 위치에 유의해주세요.</p>
            </div>
            <div class="faq-question" @click="toggle(3)">
              <span class="desktop">Q. 기존 멀티리모컨 앱과의 차이점은 무엇인가요?</span>
              <span class="mobile">Q. 기존 멀티리모컨 앱과의<br>차이점은 무엇인가요?</span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isThirdDropdownOpen}"><img src="@/assets/btn-dropdown-faq.png"></span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isThirdDropdownOpen}">
              <p>멀티 리모컨 앱은 원격 제어가 불가능합니다. 링커는 앱을 통해서 언제 어디서든지 집안 가전제품을 제어할 수 있습니다.</p>
            </div>
            <div class="faq-question"  @click="toggle(4)">
              <span class="desktop">Q. 모르는 사람이 우리집 링커를 조종하면 어떻게 하죠?</span>
              <span class="mobile">Q. 모르는 사람이 우리집<br>링커를 조종하면 어떻게 하죠?</span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isFourthDropdownOpen}"><img src="@/assets/btn-dropdown-faq.png"></span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isFourthDropdownOpen}">
              <p>모르는 사람이 링커에 접근하려면 고객이 설정한 공유코드 4자리를 알아야 합니다. 비밀번호가 유출되더라도 비밀번호 변경을 통해서 해결이 가능합니다.</p>
            </div>
            <div class="faq-question" @click="toggle(5)">
              <span class="desktop">Q. 반납은 어떻게 진행하나요?</span>
              <span class="mobile">Q. 반납은 어떻게<br>진행하나요?</span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isFifthDropdownOpen}"><img src="@/assets/btn-dropdown-faq.png"></span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isFifthDropdownOpen}">
              <p>스위처 어플 내, 스위처 정보에서 반납 신청을 해주시면 수거를 위해 우체국 기사님께서 연락 후에 방문하십니다. 반납 택배는 무료입니다.</p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  name: 'linker-faq',
  data () {
    return {
      isFirstDropdownOpen: false,
      isSecondDropdownOpen: false,
      isThirdDropdownOpen: false,
      isFourthDropdownOpen: false,
      isFifthDropdownOpen: false
    }
  },
  methods: {
    toggle: function (division) {
      switch (division) {
        case 1:
          this.isFirstDropdownOpen = !this.isFirstDropdownOpen
          break
        case 2:
          this.isSecondDropdownOpen = !this.isSecondDropdownOpen
          break
        case 3:
          this.isThirdDropdownOpen = !this.isThirdDropdownOpen
          break
        case 4:
          this.isFourthDropdownOpen = !this.isFourthDropdownOpen
          break
        case 5:
          this.isFifthDropdownOpen = !this.isFifthDropdownOpen
          break
      }
    }
  }
}
</script>
<style>
.faq-linker-hero {
  background: url("../../../assets/linker/linker-faq-hero.png") no-repeat center center;
  background-size: cover;
  min-height: 500px;
  display: flex;
  align-items: center;
}

.faq-linker-hero h1 {
  font-size: 24px;
  font-weight: bold;
  margin-left: 10%;
  color: #ffffff;
}
.m-faq-linker-hero {
  background: url("../../../assets/linker/m-linker-faq-hero.png") no-repeat center center;
  background-size: cover;
  min-height: 442px;
  text-align: left;
  padding: 41px 0px 0px 26px;
}

.m-faq-linker-hero h1 {
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
}
.m-faq-linker-hero p {
  font-size: 18px;
  margin-top: 25px;
  color: #ffffff;
}

.faq-wrapper {
  margin-top: 60px;
  margin-bottom: 60px;
}
.faq-question {
  font-size: 18px;
  padding: 23px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  cursor: pointer;
}
.faq-answer {
  border-top: solid 1px #dee2e5;
  border-bottom: solid 1px #dee2e5;
  padding: 45px;
  display: none;
}
.faq-answer p {
  font-size: 14px;
  margin: 0;
  line-height: 1.56;
  text-align: left;
}
.open {
  display: block;
  opacity: 1;
}

.dropdown-arrow {
  transition: 0.5s;
}
.dropdown-arrow img {
  width: 18px;
  height: 12px;
}
.showDropDown {
  -webkit-transform: rotate(180deg);
}

  @media only screen and (min-device-width : 320px) and (max-device-width : 568px) {
    .faq-question {
      font-size: 16px;
      padding: 20px;
      text-align: left;
      align-items: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/products/linker/LinkerFaq.vue